import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PrintComponents from "react-print-components";
import IconButton from "@material-ui/core/IconButton";
import DefaultButton from "../../../Buttons/DefaultButton/DefaultButton";
import DialogComponent from "../../../HelperComponents/DialogComponent/DialogComponent";
import PriceListLocationPicker from "../../../PriceList/PriceListLocationPicker/PriceListLocationPicker";
import {
  offerToStock,
  processReturnDispatchStatus,
} from "../../../../actions/returnDispatchesActions";
import CloseDialogIcon from "../../../../assets/image/Mask.png";
import AcceptProductSticker from "./AcceptProductSticker";
import StickerQuantityDistribution, {
  expandRowsToStickers,
} from "./StickerQuantityDistribution";
import "./AcceptProductDialog.scss";

const STATUS_OPTIONS = [
  { value: "to_return", label: "На возврат", confirmLabel: "Возврат" },
  { value: "storage", label: "На склад", confirmLabel: "На склад" },
  { value: "shortage", label: "Недовоз", confirmLabel: "Недовоз" },
];

const STEP_SELECT = "select";
const STEP_CONFIRM = "confirm";

const INITIAL_STATE = {
  status: "to_return",
  step: STEP_SELECT,
  rows: [],
  pickerLocation: "",
  pickerPriceListId: null,
  submitting: false,
};

class AcceptProductDialog extends Component {
  state = { ...INITIAL_STATE };

  printTriggerRef = React.createRef();

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({ ...INITIAL_STATE });
    }
  }

  handleQuantityChange = (rows) => {
    this.setState({ rows });
  };

  handlePrintAndAccept = () => {
    if (!this.printTriggerRef.current) return;

    const { status, submitting } = this.state;
    if (submitting) return;

    this.setState({ submitting: true });

    const handleAfterPrint = () => {
      window.removeEventListener("afterprint", handleAfterPrint);
      this.submitProcessStatus(status);
    };
    window.addEventListener("afterprint", handleAfterPrint);

    this.printTriggerRef.current.click();
  };

  submitProcessStatus = (processingStatus) => {
    const { product, processReturnDispatchStatus, onAccepted, onClose } =
      this.props;

    processReturnDispatchStatus({
      related_id: product.related_id,
      processing_status: processingStatus,
    }).then((res) => {
      this.setState({ submitting: false });
      const status = res && res.payload && res.payload.status;
      if (status >= 200 && status < 300) {
        if (onAccepted) onAccepted();
        onClose();
      }
    });
  };

  handleChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleContinue = () => {
    this.setState({ step: STEP_CONFIRM });
  };

  handleBackToSelect = () => {
    this.setState({ step: STEP_SELECT });
  };

  handlePickerChange = ({ location, priceListId }) => {
    this.setState({ pickerLocation: location, pickerPriceListId: priceListId });
  };

  handleAcceptToStock = () => {
    const { product, offerToStock, onAccepted, onClose } = this.props;
    const { pickerLocation, pickerPriceListId } = this.state;

    this.setState({ submitting: true });
    offerToStock({
      related_id: product.related_id,
      price_list: pickerPriceListId,
      location: pickerLocation,
    }).then((res) => {
      this.setState({ submitting: false });
      const status = res && res.payload && res.payload.status;
      if (status >= 200 && status < 300) {
        if (onAccepted) onAccepted();
        onClose();
      }
    });
  };

  renderSelectStep() {
    const { onClose, product } = this.props;
    const { status } = this.state;

    const acceptanceDaysLeft = product.acceptance_days_left;
    const isDaysCritical =
      typeof acceptanceDaysLeft === "number" && acceptanceDaysLeft < 5;

    return (
      <>
        <div className="title-dialog">Принять товар</div>
        <div className="accept_product_dialog__subtitle">
          Выберите статус принимаемого товара{" "}
          <span className="accept_product_dialog__product">
            {product.article_number}
            {product.name ? ` - ${product.name}` : ""}
          </span>
        </div>

        <div className="accept_product_dialog__options">
          {STATUS_OPTIONS.map((option) => (
            <label
              key={option.value}
              className="accept_product_dialog__option"
            >
              <input
                type="radio"
                name="accept_product_status"
                value={option.value}
                checked={status === option.value}
                onChange={this.handleChange}
              />
              <span className="accept_product_dialog__radio" />
              <span className="accept_product_dialog__label">
                {option.label}
              </span>
            </label>
          ))}
        </div>

        <div className="accept_product_dialog__info">
          {product.supplier_company && (
            <div className="accept_product_dialog__info-row">
              Поставщик - {product.supplier_company}
            </div>
          )}
          <div className="accept_product_dialog__info-row">
            Осталось дней с момента поставки:{" "}
            <span
              className={
                isDaysCritical ? "accept_product_dialog__days-critical" : ""
              }
            >
              {acceptanceDaysLeft != null ? acceptanceDaysLeft : "—"}
            </span>
          </div>
        </div>

        <div className="btn-wrapper order-dialog-btn">
          <DefaultButton
            variant="outlined"
            classes="cancel_btn"
            onClick={onClose}
          >
            Отмена
          </DefaultButton>
          <DefaultButton onClick={this.handleContinue}>
            Продолжить
          </DefaultButton>
        </div>
      </>
    );
  }

  renderConfirmStep() {
    const { product } = this.props;
    const {
      status,
      pickerLocation,
      pickerPriceListId,
      submitting,
    } = this.state;

    const option = STATUS_OPTIONS.find((o) => o.value === status);
    const confirmLabel = option ? option.confirmLabel : "";
    const isStorage = status === "storage";

    const storageDisabled =
      submitting || !pickerPriceListId || !pickerLocation.trim();

    const distributedTotal = this.state.rows.reduce(
      (sum, r) => sum + r.perUnit * r.unitsCount,
      0
    );
    const isFullyDistributed = distributedTotal === product.amount;
    const stickersDisabled = submitting || !isFullyDistributed;

    return (
      <>
        <div className="title-dialog">Принять товар</div>
        <div className="accept_product_dialog__confirm-text">
          {isStorage ? (
            <>
              Выберите прайс-лист и место хранения для товара{" "}
              <span className="accept_product_dialog__product">
                {product.article_number}
                {product.name ? ` - ${product.name}` : ""}
              </span>
              .
            </>
          ) : (
            <>
              Подтвердите приём товара{" "}
              <span className="accept_product_dialog__product">
                {product.article_number}
                {product.name ? ` - ${product.name}` : ""}
              </span>{" "}
              в количестве {product.amount} штук со статусом{" "}
              <b>«{confirmLabel}»</b>.
            </>
          )}
        </div>

        {isStorage ? (
          <div className="accept_product_dialog__storage">
            <PriceListLocationPicker onChange={this.handlePickerChange} />
          </div>
        ) : (
          <StickerQuantityDistribution
            availableTotal={product.amount}
            onChange={this.handleQuantityChange}
          />
        )}

        <div className="btn-wrapper order-dialog-btn">
          <DefaultButton
            variant="outlined"
            classes="cancel_btn"
            onClick={this.handleBackToSelect}
          >
            Назад
          </DefaultButton>
          {isStorage ? (
            <DefaultButton
              onClick={this.handleAcceptToStock}
              disabled={storageDisabled}
              loading={submitting}
            >
              Принять
            </DefaultButton>
          ) : (
            <DefaultButton
              onClick={this.handlePrintAndAccept}
              disabled={stickersDisabled}
              loading={submitting}
            >
              Принять
            </DefaultButton>
          )}
        </div>
      </>
    );
  }

  renderPrintBlock() {
    const { product } = this.props;
    const { rows, status } = this.state;
    if (status === "storage") return null;
    const stickers = expandRowsToStickers(rows);
    if (stickers.length === 0) return null;

    return (
      <div className="accept_product_dialog__print">
        <PrintComponents
          trigger={
            <button
              ref={this.printTriggerRef}
              type="button"
              aria-hidden="true"
              tabIndex={-1}
            />
          }
        >
          <>
            {stickers.map((sticker) => (
              <AcceptProductSticker
                key={sticker.id}
                product={product}
                amount={sticker.amount}
                acceptanceDate={product.acceptance_date}
              />
            ))}
          </>
        </PrintComponents>
      </div>
    );
  }

  render() {
    const { open, onClose, product } = this.props;
    const { step } = this.state;

    if (!product) return null;

    return (
      <DialogComponent open={open} onClose={onClose}>
        <div className="accept_product_dialog">
          {step === STEP_SELECT && this.renderSelectStep()}
          {step === STEP_CONFIRM && this.renderConfirmStep()}

          {step === STEP_CONFIRM && this.renderPrintBlock()}

          <IconButton
            classes={{ root: "dialog_close_button" }}
            onClick={onClose}
          >
            <img src={CloseDialogIcon} alt="close icon" />
          </IconButton>
        </div>
      </DialogComponent>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ offerToStock, processReturnDispatchStatus }, dispatch);

export default connect(null, mapDispatchToProps)(AcceptProductDialog);
